/**
 * Wire types shared by the /api/ai-tools routes and the tool page client.
 * The single definition both sides import — keep server and browser in step.
 */

export type PublicToolTaskStatus = 'pending' | 'processing' | 'success' | 'failed' | 'canceled';

/** What the owner's browser sees for one render — never the prompt, photos or provider ids. */
export type PublicToolTask = {
  id: string;
  status: PublicToolTaskStatus;
  stage: string | null;
  quality: string | null;
  topic: string;
  credits: number;
  createdAt: string;
  videoUrl: string | null;
  /** Photo trends: the finished image. */
  imageUrl: string | null;
  refunded: boolean;
};

/** GET /api/ai-tools/:slug/tasks */
export type ToolTasksResponse = { balance: number; tasks: PublicToolTask[] };

export function isOpenTask(task: Pick<PublicToolTask, 'status'>): boolean {
  return task.status === 'pending' || task.status === 'processing';
}
